export default __webpack_public_path__ + "assets/images/40f13dcb74f26f49c2da489278d00cd8.png";